import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-07",
  "use": "icon-sheet_icon-07-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-07\"><g transform=\"translate(-312 -217)\"><rect stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\" x=\"315.75\" y=\"219.75\" width=\"16.5\" height=\"18.5\" rx=\"2\" /><rect x=\"318\" y=\"233\" width=\"12\" height=\"1.5\" rx=\".75\" /><rect x=\"318\" y=\"228\" width=\"12\" height=\"1.5\" rx=\".75\" /><rect x=\"318\" y=\"223\" width=\"7\" height=\"1.5\" rx=\".75\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol